import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const SideBar = () => {
  const url = new URL(window.location.href);
  const pathname = url.pathname
    .split("/")
    .filter((segment) => segment.length > 0);

  const navigate = useNavigate();
  const logoutHandler = async () => {
    navigate("/login");
  };
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const toggleSubmenu = () => {
    setIsSubmenuOpen((prevState) => !prevState);
  };
  return (
    <>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <Link to={"/dashboard"} className="brand-link">
          <img src="/assets/img/logo.svg" className="brand-image " alt="logo" /> 
           {/* Go4it */}
        </Link>
        <div className="sidebar">
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column">
              <li className="nav-item">
                <Link
                  to="/dashboard"
                  className={
                    pathname[0] === "dashboard" ? "nav-link active" : "nav-link"
                  }
                >
                  {/* <img src="assets/img/icon.svg" alt="" /> */}
                  <i className="nav-icon fas fa-tachometer-alt" />
                  <p className="mtext"> Dashboard </p>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/user"
                  className={
                    pathname[0] === "user" || pathname[0] === "create-user"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  <i className="fa-solid fa-users"></i>
                  <p>User</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/activity"
                  className={
                    pathname[0] === "activity" || pathname[0] === "show-activity"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  <i className="fa-solid fa-trophy"></i>
                  <p>Activity</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/reports"
                  className={
                    pathname[0] === "reports" 
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  <i className="fa-solid fa-user-shield"></i>
                  <p>Reports</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/reviews"
                  className={
                    pathname[0] === "reviews" 
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  <i className="fa-solid fa-star"></i>
                  <p>Review</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/sport"
                  className={
                    pathname[0] === "sport" || pathname[0] === "create-sport" || pathname[0] === "edit-sport" || pathname[0] === "suggestion-sport"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  <i className="fa-solid fa-running"></i>
                  <p>Sport</p>
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="/policy"
                  className={
                    pathname[0] === "policy" || pathname[0] === "upsert-sport" 
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  <i className="fa-solid fa-file-contract"></i>
                  <p>Policy</p>
                </Link>
              </li>
              <li className={`nav-item ${isSubmenuOpen ? "menu-open" : ""}`}>
                <Link
                  className={
                    pathname[0] === "change-password" 
                      ? "nav-link active"
                      : "nav-link"
                  }
                  onClick={toggleSubmenu}
                >
                  {/* <img src="assets/img/icon4.svg" alt="Setting Icon" /> */}
                  <i className="fa-solid fa-gear"></i>
                  <p>
                    Setting{" "}
                    <i
                      className={`fas fa-angle-left right ${
                        isSubmenuOpen ? "rotated" : ""
                      }`}
                    ></i>
                  </p>
                </Link>
                {isSubmenuOpen && (
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/change-password" className="nav-link">
                        <i className="far fa-circle nav-icon"></i>
                        <p>Change Password</p>
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li className="nav-item">
                <Link to="/" className="nav-link" onClick={logoutHandler}>
                  <i className="nav-icon fa fa-sign-out" />
                  <p className="mtext"> Logout </p>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default SideBar;
